<svg xmlns="http://www.w3.org/2000/svg" width="92" height="88" viewBox="0 0 92 88">
    <defs>
        <linearGradient id="a" x1="50%" x2="50%" y1="100%" y2="0%">
            <stop offset="0%" stop-color="#FFF"/>
            <stop offset="100%" stop-color="#FFF"/>
        </linearGradient>
        <linearGradient id="b" x1="50%" x2="50%" y1="41.129%" y2="66.71%">
            <stop offset="0%" stop-color="#D90338"/>
            <stop offset="100%" stop-color="#0069C4"/>
        </linearGradient>
    </defs>
    <g fill="none" fill-rule="evenodd">
        <path fill="url(#a)" stroke="#D9DDDF" stroke-width="2.25" d="M1.125 1.125h89.75v85.75H1.125z"/>
        <path stroke="#D90338" stroke-linecap="square" stroke-width="2.5" d="M21 29.253l49.998.494"/>
        <path stroke="#006AC8" stroke-linecap="square" stroke-width="2.5" d="M21 62.253l49.998.494"/>
        <path fill="url(#b)" d="M2 9h31v51H2z" transform="translate(28 12)"/>
        <path stroke="#FFF" stroke-linecap="square" stroke-width="2.4" d="M28.5 74.5l37-62" opacity=".7"/>
    </g>
</svg>
